export const GET_ALL_MODULES_REQUEST = "GET_ALL_MODULES_REQUEST";
export const GET_ALL_MODULES_SUCCESS = "GET_ALL_MODULES_SUCCESS";
export const GET_ALL_MODULES_FAIL = "GET_ALL_MODULES_FAIL";

export const SAVE_ENTITY_MODULES_REQUEST = "SAVE_ENTITY_MODULES_REQUEST";
export const SAVE_ENTITY_MODULES_SUCCESS = "SAVE_ENTITY_MODULES_SUCCESS";
export const SAVE_ENTITY_MODULES_FAIL = "SAVE_ENTITY_MODULES_FAIL";

export const GET_ENTITY_MODULES_REQUEST = "GET_ENTITY_MODULES_REQUEST";
export const GET_ENTITY_MODULES_SUCCESS = "GET_ENTITY_MODULES_SUCCESS";
export const GET_ENTITY_MODULES_FAIL = "GET_ENTITY_MODULES_FAIL";
